<template>
  <v-btn icon @click="dark = !dark" class="neumorphism-out mr-5" :title="$t('nav.tooltipMode')">
    <v-icon>mdi-{{dark ? "white-balance-sunny" : "moon-waning-crescent"}}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "theme-btn",
  data() {
    return {
      dark: false,
    };
  },
  mounted() {
    this.root = document.documentElement;
  },
  watch: {
    dark() {
      this.toggle();
    },
  },
  methods: {
    toggle() {
      let cookiesConfig = $cookies.get("config");

      if (this.dark) {
        cookiesConfig.theme = "dark";
        $cookies.set("config", cookiesConfig, "1y");
        this.$vuetify.theme.dark = true;
        this.root.style.setProperty("--text-color", "var(--dark-text-color)");
        this.root.style.setProperty(
          "--border-color",
          "var(--dark-border-color)"
        );
        this.root.style.setProperty(
          "--shadow-light",
          "var(--dark-color-shadow-light)"
        );
        this.root.style.setProperty(
          "--shadow-dark",
          "var(--dark-color-shadow-dark)"
        );
        this.root.style.setProperty(
          "--weekend-bg-color",
          "var(--dark-weekend-bg-color)"
        );
        this.root.style.setProperty("--main-bg-color", "var(--color-bg-dark)");
        this.root.style.setProperty(
          "--info-card-shadow",
          "var(--dark-elevation-color)"
        );
        this.root.style.setProperty("--card-color", "var(--dark-card-color)");
      } else {
        cookiesConfig.theme = "light";
        $cookies.set("config", cookiesConfig, "1y");
        this.$vuetify.theme.dark = false;
        this.root.style.setProperty("--text-color", "var(--light-text-color)");
        this.root.style.setProperty(
          "--shadow-light",
          "var(--light-color-shadow-light)"
        );
        this.root.style.setProperty(
          "--shadow-dark",
          "var(--light-color-shadow-dark)"
        );
        this.root.style.setProperty(
          "--weekend-bg-color",
          "var(--light-weekend-bg-color)"
        );
        this.root.style.setProperty(
          "--border-color",
          "var(--light-border-color)"
        );
        this.root.style.setProperty("--main-bg-color", "var(--color-bg-light)");
        this.root.style.setProperty(
          "--info-card-shadow",
          "var(--light-elevation-color)"
        );

        this.root.style.setProperty("--card-color", "var(--light-card-color)");
      }
    },
  },
};
</script>

<style></style>
